import { render } from "./Share.vue?vue&type=template&id=9a0d9514&scoped=true&ts=true"
import script from "./Share.vue?vue&type=script&lang=ts"
export * from "./Share.vue?vue&type=script&lang=ts"

import "./Share.vue?vue&type=style&index=0&id=9a0d9514&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a0d9514"]])

export default __exports__